import { Text } from '@spotify-internal/encore-web';
import styled from 'styled-components';
import { DELAYS, fadeInAnimation, withAnimationContext, } from '../../Animations';
export const Body = withAnimationContext(styled(Text).attrs({
    variant: 'bodyMedium',
    className: 'body',
}) `
    ${fadeInAnimation(DELAYS.FOURTH)};
    display: block;
  `);
